import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"

import StyledPaper from "/components/paper"

import image from '/assets/dashboard/invoice.png'

const Billing = () => {

  const navigate = useNavigate()

  return (
    <StyledPaper width={250} height={250}>
      <div onClick={() => navigate("/billing")} className="link flex flex-col items-center justify-top h-full">
        <Typography variant="h5">Billing & Plans</Typography>
      </div>
      <div onClick={() => navigate("/billing")} className="link relative">
        <img src={image} style={{ position: "absolute", left: "50%", bottom: 20, height: "130px", display: "inline-block", transform: "rotate(10deg) translateX(-50%)", filter: "drop-shadow(0 8px 12px rgba(0, 0, 0, 1))", }} />
      </div>
    </StyledPaper>
  )
}

export default Billing